import { Component } from '@angular/core';
import { DynamicOrchestrator, provideDynamicOrchestrator } from '@games/shared/orchestrator';

class SpeedReadingResultOrchestrator extends DynamicOrchestrator<{ buttonCount: number }> {
  provideAny() {
    this.form({
      padding: {
        for: 'outerBox',
        height: 5,
        top: 1,
        bottom: 0.4,
        width: 6,
        horizontal: 0,
      },
      for: 'outerBox',
      column: [
        {
          for: 'blockWrapper',
          take: 5,
          maxWidth: 700,
        },
        {
          for: 'gap',
          take: 0.3,
        },
        {
          for: 'buttonContainer',
          take: 1.5,
          heightToWidth: 0.3,
          row: [
            {
              for: 'button',
              take: 1,
              multiple: true,
              // stretchWidth: 1 / this.context.buttonCount,
            },
          ],
        },
      ],
    });
  }
}

@Component({
    selector: 'ms-speed-reading-result',
    templateUrl: './speed-reading-result.component.html',
    styleUrls: ['./speed-reading-result.component.scss'],
    providers: [provideDynamicOrchestrator(SpeedReadingResultOrchestrator)],
    standalone: false
})
export class SpeedReadingResultComponent {
  orchestratorContext = {
    buttonCount: 2,
  };
}
